// components/TabsView.tsx
import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { Tab as TabType } from '../types';

interface TabsViewProps {
  tabs: TabType[];
  activeTabId: string;
  onTabChange: (tabId: string) => void;
}

export const TabsView: React.FC<TabsViewProps> = ({ tabs, activeTabId, onTabChange }) => {
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    onTabChange(newValue);
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
      <Tabs
        value={activeTabId}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="task tabs"
      >
        {tabs.map((tab) => (
          <Tab key={tab.id} label={tab.name} value={tab.id} />
        ))}
      </Tabs>
    </Box>
  );
};
